<template>
  <div id="container">
    <div class="box_one" >
      <cont-top/>
    </div>
    <div class="main" style="margin-bottom:5px">

      <div class="title">
        <div class="title_name"></div>
      </div>

      <div class="clear" style="padding: 0 40px">
        2003年 <br/>
        6月 大阪市东淀川区法人登记 <br/>
        10月 大阪府摄津市鸟饲本町开始营业 <br/>
        12月 刹车碟PD/SD发售（约500个型号） <br/>
        <div style="height:16px"></div>

        2004年 <br/>
        2月 刹车碟HD/HS发售 <br/>
        3月 颜色合头订制刹车碟发售、刹车片M/Z/发售（约300个型号） <br/>
        4月 刹车片R01/RD/RN发售、开始供货给日本超级耐久赛车队 <br/>
        <div style="height:16px"></div>

        2005年 <br/>
        3月 斯巴鲁车型专供冷却效果出众的DAV刹车碟发售 <br/>
        4月 刹车油DOT4发售 <br/>
        5月 SUV车用刹车片X发售、漂移专用后刹车片D发售 <br/>
        5月 刹车碟型号700个突破、刹车片型号400个突破 <br/>
        11月 性价比出色的刹车皮Premium发售 <br/>
        <div style="height:16px"></div>

        2006年 <br/>
        4月 参加东京进口车展览 <br/>
        6月 刹车片型号600个突破、刹车碟型号1000个突破 <br/>
        7月 赛道竞技用防开裂性能出众的刹车碟FP/FS发售 <br/>
        8月 两片式FP/FS发售 <br/>
        <div style="height:16px"></div>

        2007年 <br/>
        1月 刹车碟引入防锈涂层工艺 <br/>
        5月 参加东京进口车展览 <br/>
        7月 刹车片型号650个突破、刹车碟型号1100个突破 <br/>
        12月 刹车碟型号1200个突破 <br/>
        <div style="height:16px"></div>

        2008年 <br/>
        4月 公司改名“株式会社DIXCEL” <br/>
        5月 刹车片型号700个突破、刹车碟型号1300个突破 <br/>
        12月 刹车碟型号1400个突破 <br/>
        <div style="height:16px"></div>

        2009年 <br/>
        3月 刹车油328racing发售 <br/>
        4月 参加上海车展 <br/>
        5月 刹车片型号800个突破 <br/>
        8月 刹车碟型号1500个突破、各系列产品更新包装（沿用至今） <br/>
        10月 卡钳测温贴发售 <br/>
        12月 刹车片EC/ES发售 <br/>
        <div style="height:16px"></div>


        2010年  <br/>
        2月 刹车片型号900个突破  <br/>
        3月 与日本SuperGT车手田中哲也签订研发技术顾问协议  <br/>
        8月 刹车碟型号1600个突破、刹车片型号1000个突破、DIXCEL R&D成立  <br/>
        10月 参加天津车展  <br/>
        12月 实习生制度开始实施  <br/>
        <div style="height:16px"></div>

        2011年  <br/>
        3月 赛道竞技专用刹车片RA/Specomα、β发售、东日本大震灾支援活动开始  <br/>
        4月 参加上海车展  <br/>
        5月 签约赞助韩寒所在的CTCC上海大众333车队  <br/>
        6月 东日本大震灾复兴支援计划“绝不认输！日本！”开始  <br/>
        8月 “绝不认输！日本！”活动募集捐款500万日元突破  <br/>
        8月 DIXCEL中国成立、刹车片型号1100个突破  <br/>
        10月 参加上海CHINA AUTO SALON  <br/>
        12月 DIXCEL FACEBOOK专业开设  <br/>
        <div style="height:16px"></div>

        2012年  <br/>
        1月 参加东京改装车展、“绝不认输！日本！”活动募集捐款突破1000万日元、两片式浮动盘套件发售  <br/>
        2月 参加大阪改装车展  <br/>
        10月 SpcomK发售  <br/>
        12月 刹车油DOT5.1发售  <br/>
        <div style="height:16px"></div>

        2013年  <br/>
        1月 参加东京改装车展 <br/>
        3月 刹车碟型号1800个突破 <br/>
        5月 DIXCEL FACEBOOK100000个“I like”达成 <br/>
        8月 R35GTR前400mm浮动碟套件发售 <br/>
        9月 参加上海CHINA AUTO SALON <br/>
        <div style="height:16px"></div>

        2014年  <br/>
        1月 参加东京改装车展  <br/>
        2月 参加大阪改装车展 <br/>
        9月 参加上海CHINA AUTO SALON <br/>
        11月 使用DIXCEL产品的SuperGT300“GAINER DIXCEL SLS”车队获得年度车队冠军 <br/>
        12月 FACEBOOK 500000个“I like”达成、刹车片型号1200个、刹车碟型号2000个突破 <br/>
         <div style="height:16px"></div>

        2015年 <br/>
        1月 参加东京改装车展 <br/>
        2月 参加大阪改装车展 <br/>
        6月 参加北京AIT <br/>
        9月 参加上海CHINA AUTO SALON <br/>
        12月 “DIXCLE磨耗保证”制度开始、ES型号追加欧美车系列 <br/>
         <div style="height:16px"></div>

        2016年 <br/>
        1月 参加东京改装车展 <br/>
        2月 参加大阪改装车展 <br/>
        3月 刹车皮型号1200个突破、刹车碟型号2100个突破 <br/>
        10月 参加上海CHINA AUTO SALON <br/>
        11月 DIXCEL中国搬入新办公楼、新仓库 <br/>
         <div style="height:16px"></div>

        2017年 <br/>
        1月 参加东京改装车展 <br/>
        2月 参加大阪改装车展 <br/>
        8月 刹车皮型号1400个突破、刹车碟型号2200个突破 <br/>
        10月 参加上海CHINA AUTO SALON <br/>
        12月 参加大阪车展 <br/>
         <div style="height:16px"></div>

        2018年 <br/>
        1月 参加东京改装车展 <br/>
        2月 参加大阪改装车展 <br/>
        3月 参加IAAE、成为FIA 亚洲F3刹车部件官方供应商、成为亚洲宝珀GT官方合作伙伴 <br/>
        4月 参加俄罗斯VIAS <br/>
        7月 DIXCEL日本搬入新办公楼、新仓库 <br/>
        10月 竞技刹车油DUR发售 <br/>
         <div style="height:16px"></div>

        2019年 <br/>
        1月 参加东京改装车展 <br/>
        2月 参加大阪改装车展 <br/>
        3月 参加大阪IAAE、DIXCEL综合商品目录VOL7完成 <br/>
         <div style="height:16px"></div>

        2020年 <br/>
        1月 参加东京改装车展 <br/>
        2月 参加大阪改装车展 <br/>
        5月 DIXCEL成为吉利超吉联赛官方刹车产品供应商。<br/>
        5月 DIXCEL成为领克03＋官方试驾体验营刹车产品供应商。<br/>
        10月 DIXCEL中国参加东莞ALL IN TUNING。<br/>
        11月 DIXCEL中国“DIXCELONLINE经销商采购平台”手机端上线。<br/>
        <div style="height:16px"></div>

        2021年 <br/>
        2月 DIXCEL中国“DIXCELONLINE经销商采购平台”PC端上线。<br/>
        3月 DIXCEL中国新版官网上线。<br/>
        3月 DIXCEL中国10周年LOGO发布。<br/>
        4月 出展2021九州汽车生态展。<br/>
        <div style="height:16px"></div>

        2022年 <br/>
        1月 全新S系列刹车片上市<br/>
        <div style="height:16px"></div>

        2023年 <br/>
        4月 DIXCEL中国佛山分仓投入使用<br/>
        <div style="height:16px"></div>

        2024年 <br/>
        3月 出展2024年苏州GT SHOW<br/>
        8月 DIXCEL中国西南（成都）分仓投入使用<br/>
        10月 2024赛季超吉联赛PROTeam DIXCEL强势包揽年度双冠<br/>
        <div style="height:16px"></div>

        2025年 <br/>
        2月 出展2025年北京雅森AIT<br/>
        3月 出展2025年苏州GT SHOW<br/>
        4月 成为TOYOTA GAZOO Racing CHINA GR86 Cup赛事官方指定刹车品牌<br/>
        8月 DIXCEL中国北京分仓正式投入使用<br/>
        9月 DIXCEL DOT5.1 EHV 电动车/混动车刹车油上市<br/>
        10月 刹车片型号1700个，刹车碟型号2700个达成<br/>
        <div style="height:16px"></div>

        2026年 <br/>
        1月 DIXCEL卡钳测温贴焕新上市<br/>
        3月 出展2026年苏州GT SHOW<br/>
        10月 DIXCEL中国（佛山分仓）出展AIT东莞改装展<br/>
        10月 “DIXCEL官方平台”小程序上线<br/>
        <div style="height:16px"></div>

      </div>

    </div>
    <div class="box_bottom" >
      <cont-bottom/>
    </div>
  </div>
</template>

<script>
import ContTop from './Cont_top'
import ContBottom from '@/views/Components/Cont_bottom'


export default {
  data() {
    return {
      fit : 'contain'
    }
  },
  components : {
    ContTop ,
    ContBottom ,
  }
}

</script>

<style lang="stylus" scoped>
.clear:after {
  display: block;
  clear: both;
  content: '';
}

#container
  background-color : #000
  .box_one
    width: 100%;
    // background: url("~@/assets/image/brand/img1.png");
    background-repeat : no-repeat
    background-size : cover
    background-color #000

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 55px 0 44px
}

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/brand/BrandHistory/img1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 23px 53px 25px 58px;
  box-sizing: border-box;
}

.title_name {
  width: 97px;
  height: 59px;
  background: url('~@/assets/image/brand/BrandHistory/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}

</style>
